import React from 'react'
import { CardContainer, ProfileImage, UserInfo, UserName, BadgeContainer } from './AppointmentCard.styled'
import DefaultAvatar from '../../images/ghost.svg'

interface AppointmentRowProps {
  item?: any
  name?: string
  avatar?: string
  badges?: React.ReactNode | React.ReactNode[]
  cardStyle?: React.CSSProperties
  nameStyle?: React.CSSProperties
  profileImageStyle?: React.CSSProperties
  badgeContainerStyle?: React.CSSProperties
  cardProps?: React.HTMLAttributes<HTMLDivElement>
  onClick?: () => void
  onMouseDown?: () => void
  onMouseUp?: () => void
  onMouseLeave?: () => void
  onTouchStart?: () => void
  onTouchEnd?: () => void
}

export default function AppointmentRow({
  onClick,
  item,
  name,
  avatar,
  badges,
  cardStyle,
  nameStyle,
  profileImageStyle,
  badgeContainerStyle,
  cardProps,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  onTouchStart,
  onTouchEnd,
}: AppointmentRowProps) {
  return (
    <CardContainer
      style={cardStyle}
      {...cardProps}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <ProfileImage
        src={avatar || DefaultAvatar}
        style={profileImageStyle}
        // onClick={(e) => e.stopPropagation()}
        // onMouseDown={(e) => e.stopPropagation()}
        // onTouchStart={(e) => e.stopPropagation()}
        // onTouchEnd={(e) => e.stopPropagation()}
        // onTouchCancel={(e) => e.stopPropagation()}
      />

      <UserInfo>
        <UserName style={nameStyle}>{name}</UserName>
      </UserInfo>

      <BadgeContainer
        style={badgeContainerStyle}
        // onClick={(e) => e.stopPropagation()}
        // onMouseDown={(e) => e.stopPropagation()}
        // onTouchStart={(e) => e.stopPropagation()}
        // onTouchEnd={(e) => e.stopPropagation()}
        // onTouchCancel={(e) => e.stopPropagation()}
      >
        {badges && Array.isArray(badges) ? badges.map((b, i) => <React.Fragment key={i}>{b}</React.Fragment>) : badges}
      </BadgeContainer>
    </CardContainer>
  )
}
